Shopify.theme.sections.register('slider', {
  onLoad() {
    this._initSlider();
  },

  onUnload() {
  },

  onSelect() {
    window.llUpdate();
    Shopify.theme.getInstances('hero')
      .forEach(function(instance) {
        instance.refresh();
      });
  },

  onDeselect() {
  },

  onBlockSelect() {
  },

  onBlockDeselect() {
  },

  _initSlider() {
    if (!this.container.classList.contains("double")) {
      return;
    }
    
    this.slidesWrapper = this.container.querySelector('.slides');
    this.slidesWrapper.classList.add('swiper-wrapper');

    this.slides = this.container.querySelectorAll('.slide');
    this.slides.forEach(slide => {
      slide.classList.add('swiper-slide');
    });

    this.prevButton = document.createElement('div');
    this.prevButton.classList.add('swiper-button-prev');
    this.container.append(this.prevButton);
    this.nextButton = document.createElement('div');
    this.nextButton.classList.add('swiper-button-next');
    this.container.append(this.nextButton);

    new Swiper(this.container, {
      allowTouchMove: true,
      autoplay: false,
      direction: 'horizontal',
      loop: true,
      slidesPerView: 1,
      speed: 1000,
      navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
      },

      breakpointsInverse: true,
      breakpoints: {
        768: {
          allowTouchMove: false,
          loop: false,
          navigation: false,
          slidesPerView: 2,
        }
      },

      on: {
        init: () => {
          window.llUpdate()
        },
      },
    });
  }
});
